<template>
    <div class="container">
        <img v-if="footerImage1.display" :src="footerImage1.url" alt="" width="85%">
        <img v-if="footerImage2.display" :src="footerImage2.url" alt="" width="70%" style="padding-top: 10px;">
        <div v-if="htmlCopywriteText.display" v-html="htmlCopywriteText.text"></div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';

const gameStore = useGameStore()
const footerImage1 = ref<FooterImagesItem>({
    display: false,
    url: '',
    redirectUrl: ''
})
const footerImage2 = ref<FooterImagesItem>({
    display: false,
    url: '',
    redirectUrl: ''
})
const htmlCopywriteText = ref({
    display: false,
    text: ''
})
const props = defineProps<{
    itemData: {
        footerImage1: FooterImagesItem,
        footerImage2: FooterImagesItem,
        htmlCopywriteText: {
            display: boolean
            text: string
        }
    }
}>()
const emits = defineEmits(['openContactPopup'])

onMounted(() => {
    footerImage1.value = props.itemData.footerImage1
    footerImage2.value = props.itemData.footerImage2
    htmlCopywriteText.value = props.itemData.htmlCopywriteText
})
</script>
<style scoped>
.container {
    padding: 5px 15px 70px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    background: rgb(2, 74, 73);
    font-weight: 400;
    font-family: system-ui;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}
@media (max-width : 420px){
    .container{
       font-size: 14px; 
    }
}
</style>